<template>
    <div class="form-item">
        <div class="form-label">
            <label v-if="label != null">{{ label }}</label>
        </div>
        <div class="form-value">
            <el-cascader size="small" style="width: 170px" :options="dataListInner" :props="props" :filterable="filterable && !multiple" :collapseTags="collapseTags" clearable @change="syncModel"></el-cascader>
        </div>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    //有效的值类型
    let validValueTypes = ['Integer', 'String'];

    function isValidValueType(valueType) {
        return validValueTypes.indexOf(valueType) != -1;
    }

    //转为指定的类型
    function castToTypedValue(srcValue, valueType) {
        let resultValue = srcValue;
        if(resultValue == null) {
            resultValue = null;
        }
        else {
            if(valueType == 'Integer') {
                resultValue = Utils.ParseInt(resultValue);
            }
            //String
        }
        return resultValue;
    }

    export default {
        name: 'swb-query-casc-field',
        //
        props: {
            valueType: {
                type: String,
                default: 'Integer'
            },
            label: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            dataList: {//{ id, label, value }
                type: Array,
                default: []
            },
            filterable: {//是否支持输入过滤条目（多选时不支持，因为导致界面错乱）
                type: Boolean,
                default: false
            },
            multiple: {//是否多选
                type: Boolean,
                default: false
            },
            collapseTags: {//多选时是否将选中值按文字的形式展示
                type: Boolean,
                default: true
            }
        },
        //
        data() {
            return {
                props: {
                    multiple: false
                },
                dataListInner: [],
                //
                curValue: null
            };
        },
        watch: {
            valueType(newVal, oldVal) {
                this.init();
            },
            dataList(newVal, oldVal) {
                this.init();
            },
            multiple(newVal, oldVal) {
                this.init();
            }
        },
        //
        created() {
            this.init();
        },
        beforeDestroy() {
            //data
            this.curValue = null;
            this.dataListInner = null;
            this.props = null;
        },
        //
        methods: {
            init() {
                if(!isValidValueType(this.valueType)) {
                    let message = '组件的值类型有误，可用的值类型为：' + validValueTypes.join(", ");
                    if(typeof Toast !== 'undefined') {
                        Toast.show(message, 3000, 'error');
                    }
                    else {
                        MsgBox.error(message);
                    }
                }
                //
                this.$set(this.props, 'multiple', this.multiple);
                //
                this.dataListInner = Utils.copyAsArray(this.dataList || []);
                //
                if(this.multiple) {
                    if(!Utils.isArray(this.curValue)) {
                        this.curValue = [];
                    }
                }
                else {
                    if(Utils.isArray(this.curValue)) {
                        this.curValue = null;
                    }
                }
                //
                this.syncModel();
            },
            syncModel(curValue) {
                if(this.multiple) {
                    if(curValue != null) {
                        this.curValue = [];
                        for(let i = 0, c = curValue.length; i < c; i++) {
                            this.curValue.push(castToTypedValue(curValue[i].last(), this.valueType));
                        }
                    }
                }
                else {
                    if(curValue != null) {
                        this.curValue = castToTypedValue(curValue.last(), this.valueType);
                    }
                }
                //
                this.triggerEvent();
            },
            //
            triggerEvent() {
                let resultValue = this.multiple ? Utils.copyAsArray(this.curValue) : this.curValue;
                //
                this.$emit('input', resultValue);
                this.$emit('change', resultValue);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/query/QueryCascField.vue